// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class InitialResetPasswordRequestModel {
    static getAttributeTypeMap() {
        return InitialResetPasswordRequestModel.attributeTypeMap;
    }
}
InitialResetPasswordRequestModel.discriminator = undefined;
InitialResetPasswordRequestModel.attributeTypeMap = [
    {
        "name": "emails",
        "baseName": "emails",
        "type": "Array<string>"
    }
];
//# sourceMappingURL=initialResetPasswordRequestModel.js.map